// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3973":"7ed64251","7295":"416698fa"}[chunkId] + ".chunk.css";
};